import css from "styled-jsx/css";

export default css`
  .width-50 {
    width: 48%;
  }

  .width-100 {
    width: 100%;
  }
  .title {
    width: 60%;
    height: 40px;
    margin-top: 1rem;
    margin-bottom: 1rem;
    border-radius: 8px;
  }

  .products {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .product {
      height: 90px;
      border-radius: 8px;
      margin-bottom: 1rem;
    }
  }
`;
